<template>
  <div class="layout__position-left layout__width-100">

    <el-form
      :model="searchParams"
      status-icon
      :rules="{}"
      ref="searchParams"
    >

      <div class="layout__padding-clear text__align-center layout__width-100">
        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Month Range</p>
          <el-form-item prop="salesDateRange">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="left"
              start-placeholder="Start Month"
              end-placeholder="End Month"
              :picker-options="pickerOptions"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <el-button
      class="button-red button__base button__insights"
      v-on:click="getSales('searchParams')"
    >
      Refresh Data
    </el-button>

    <el-button
      class="button-teal button__base button__insights"
      :disabled="this.sales.length === 0"
      v-on:click="csv()"
    >
      Download CSV
    </el-button>

  </div>

</template>

<script>

import Axios from 'axios';
import moment from 'moment';
import download from 'downloadjs';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import LapsedBranches from '../../enums/LapsedBranches';

export default {
  name: 'LapsedBranchesSearch',
  mixins: [axios, csvDownloadHelper, dataFormatter],
  props: {
    searchParams: {},
    sales: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_lapsed_branches.csv',
      invoicedValue: 'A',
      lapsedBranches: LapsedBranches,
      invoicedArray: [
        {
          value: 'A',
          label: 'All',
        },
        {
          value: 'I',
          label: 'Invoiced',
        },
        {
          value: 'N',
          label: 'Not Invoiced',
        },
      ],
      dateRange: [],
      downloadUrl: '',
      myChart: Object,
      pickerOptions: {},
      // pickerOptions: {
      //   shortcuts: [{
      //     text: 'This month',
      //     onClick(picker) {
      //       picker.$emit('pick', [
      //         new Date(),
      //         new Date(),
      //       ]);
      //     },
      //   }, {
      //     text: 'This year',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date(new Date().getFullYear(), 0);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: 'Last 6 months',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setMonth(start.getMonth() - 6);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }]
      // }
    };
  },
  created() {
    console.log('CREATED');
    const date = new Date();
    date.setDate(date.getDate() - 7);
    console.log('created date');

    console.log(this.searchParams);

    this.dateRange = this.searchParams.salesDateRange;
  },
  mounted() {
    console.log('MOUNTED');
    this.getSales('searchParams');
  },
  destroyed() {
    console.log('DESTROYED');

    console.log(this.searchParams);
  },
  beforeUpdate() {
    window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
  },
  methods: {
    swapInvoiced: function (component) {
      console.log('dropdownValue=' + this.invoicedValue);
      // this.currentComponent = component;
    },
    getSales(searchParams) {

      this.$refs[searchParams].validate((valid) => {
        if (valid) {

          console.log('before');
          console.log(this.searchParams);

          let searchTerms = Object.assign({}, this.searchParams);
          console.log('searchTerms');
          console.log(searchTerms);

          console.log('after search is copied');
          console.log(this.searchParams);

          console.log('after search is copied - new object');
          console.log(searchTerms);

          const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetLapsedCustomers?startDate=${this.dateRange[0]}&endDate=${this.dateRange[1]}`;

          console.log(endpoint);

          this.$parent.loading = true;

          Axios.get(endpoint, this.returnHeaderUsingToken())
            .then(response => {
              var lookup = {},
                result = [],
                dates = [],
                custNo = 0,
                orderDate,
                lapsedBranches = response.data;

              lapsedBranches = lapsedBranches.map((lapsedBranch) => {
                return {
                  ...lapsedBranch,
                };
              });

              this.$parent.sales = lapsedBranches;

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });
            })
            .catch(error => {
              if (error.response) {
                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
              }

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });

              this.$parent.sales = [];
            });
        } else {
          return false;
        }
      });
    },
    csv() {
      const fields = this.lapsedBranches.createLabelValueList();

      this.downloadCsv(this.exportDate, fields, this.sales);
    }
  }
};
</script>